const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/settings/nutrition-plans/new.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/settings/nutrition-plans/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getLatestWeightQuery } from '@/features/weight-tracking/lib/get-latest-weight.query';
export const Route = createFileRoute('/_authenticated/settings/nutrition-plans/new')({
  loader: async ({
    context,
    location
  }) => {
    try {
      await context.queryClient.ensureQueryData(getLatestWeightQuery({
        controllers: {
          weightTrackingController: context.deps.controllers.weightTrackingController
        }
      }));
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});